import React, { useEffect, useState } from 'react';
import { IIconProps } from '../interfaces';
import { getSVGHeight } from '../svg-provider';

const CartIcon = (props: IIconProps) => {

    const [height, setHeight] = useState(props.height);
    useEffect(() => {

        // if height property is not defined, and width & height should be defined in px ->
        // calculate the height dynamically, keeping the aspect ratio using the viewport
        if(height === undefined && props.width.endsWith('px')){
            setHeight(getSVGHeight(props.width, 22, 19));
        }
    }, [height, props.width]);

    return (
        <svg
            width={ props.width }
            height={ height }
            className={ props.classes }
            style={ props.style }
            viewBox="0 0 22 19" xmlns="http://www.w3.org/2000/svg">
            { props.title && <title>{ props.title }</title> }
            <path d="M8 15a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm8 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM4.446 0l3.842 8.257h7.266l3.65-6.374a1 1 0 1 1 1.735.994l-4.226 7.38H7.67L7 11.744h10.502a1 1 0 1 1 0 2H7a2 2 0 0 1-1.823-2.822l1.05-2.333.005-.01L3.171 2H1a1 1 0 1 1 0-2h3.446z" fill={ props.color } /></svg>
    )
};

export default CartIcon;
